<div class="flex-fill d-flex flex-column">
    <!-- <div class="card">
        <div class="card-body" style="max-width: 1050px;">
            <dx-form [formData]="filter" appAutofocusForm="partNumber" [colCount]="3" (onEditorEnterKey)="search()">
                <dxi-item itemType="group">
                    <dxi-item dataField="partNumber"></dxi-item>
                    <dxi-item dataField="vendor"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group">
                    <dxi-item dataField="description"></dxi-item>
                    <dxi-item dataField="partType"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colSpan]="2">
                    <dxi-item dataField="mfgPartNumber" [label]="{ text: 'Mfg Tag #' }"></dxi-item>
                    <dxi-item dataField="mfgDecription" [label]="{ text: 'Mfg Tag #' }"></dxi-item>
                </dxi-item>
            </dx-form>
            <div class="btn-toolbar justify-content-end mt-3">
                <div *ngIf="orders" class="me-3">{{ orders.length }} {{ orders.length === 1 ? 'item found' : 'items found' }}</div>
                <button type="button" accesskey="s" (click)="search()" class="btn btn-primary" [disabled]="true">Search</button>
                <button type="button" (click)="clear()" class="btn btn-light ms-2" [disabled]="true">Clear</button>
            </div>
        </div>
    </div> -->
    <div class="m-1 grid-fill" *ngIf="customers">
        <dx-data-grid
            #dataGrid
            [dataSource]="customers"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onExporting)="onExporting($event)"
        >
            <!-- <dxi-column dataField="invoiceNumber" width="80"></dxi-column> -->
            <!-- <dxi-column dataField="customerLocation.customer.customerName" caption="Customer Name" width="200" cellTemplate="nameTemplate">
                <div *dxTemplate="let d of 'nameTemplate'">
                    <a [routerLink]="'../workorder/' + d.data.id">{{ d.value || '(blank)' }}</a>
                </div>
            </dxi-column> -->
            <dxi-column dataField="companyName" width="250"></dxi-column>
            <dxi-column dataField="contactName" width="250"></dxi-column>
            <dxi-column dataField="email" width="200"></dxi-column>
            <dxi-column dataField="billAddress1"></dxi-column>
            <dxi-column dataField="billAddress2"></dxi-column>
            <dxi-column dataField="billCity"></dxi-column>
            <dxi-column dataField="billState" width="80"></dxi-column>
            <dxi-column dataField="phone1" width="200"></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="customer-search-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)" class="btn btn-success">Open</button>
                <button (click)="open()" class="btn btn-secondary ms-2">New</button>

                <!-- <button
                    type="button"
                    class="btn btn-danger ms-2"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    [hidden]="!auth.hasRole('Administrator')"
                >
                    Delete
                </button> -->
            </div>
        </dx-data-grid>
    </div>
</div>
